import { RawRecord, ScheduledOrigin } from './ScheduledOrigin';

export class ScheduledUpdater {
    constructor(private readonly workspaceId: number) {}

    // Needed for making removing effective
    private indices: Map<number, ScheduledOrigin> = new Map<number, ScheduledOrigin>();
    private origins: Map<string, ScheduledOrigin> = new Map<string, ScheduledOrigin>();
    private _version = 0;

    get version(): number {
        return this._version;
    }

    addData(data: RawRecord[]): void {
        this.origins.clear();
        this.update(data);
    }

    update(data: RawRecord[]): void {
        let hasBeenUpdated = false;
        for (const record of data) {
            if (!(this.workspaceId in record.filterState)) {
                continue;
            }

            const { origin: originName, originPosition } = record;
            if (!originName || !originPosition) {
                continue;
            }

            let origin: ScheduledOrigin;
            if (this.origins.has(originName)) {
                origin = <ScheduledOrigin>this.origins.get(originName);
            } else {
                origin = new ScheduledOrigin(record);
                this.origins.set(originName, origin);
            }
            if (origin.addOrUpdate(record)) {
                // The new item. Add to indices.
                this.indices.set(record.id, origin);
            }
            hasBeenUpdated = true;
        }
        if (hasBeenUpdated) {
            this._version++;
        }
    }

    remove(deleted: { all: number[]; workspaces: Record<number, number[]> }): void {
        let hasBeenRemoved = false;
        for (const id of [...deleted.all, ...deleted.workspaces[this.workspaceId]]) {
            if (!this.indices.has(id)) {
                continue;
            }
            // Get origin containig the flight
            const origin = this.indices.get(id);
            origin!.remove(id);
            this.indices.delete(id);
            hasBeenRemoved = true;
            if (origin?.isEmpty) {
                this.origins.delete(origin.name);
            }
        }
        if (hasBeenRemoved) {
            this._version++;
        }
    }

    getPlanned(): ScheduledOrigin[] {
        return Array.from(this.origins.values().filter((x) => x.countPlanned > 0));
    }

    getScheduled(): ScheduledOrigin[] {
        return Array.from(this.origins.values().filter((x) => x.countSheduled > 0));
    }
}
